document.addEventListener('DOMContentLoaded', function() {
    var bannerBoxes = document.querySelectorAll('.banner-button-box');

    bannerBoxes.forEach(function(box) {
        box.addEventListener('mouseover', function() {
            var imageId = this.getAttribute('data-image-id'); // Get the data-image-id from the banner-box
            var blockSection = this.closest('.quiz-inner'); // Find the parent .quiz-inner container
            var images = blockSection.querySelectorAll('.quiz-images[data-image-id="' + imageId + '"]'); // Select all .quiz-images with matching data-image-id
            
            images.forEach(function(image) {
                image.classList.add('hovered'); // Add the 'hovered' class to each matched .quiz-images
            });
        });

        box.addEventListener('mouseleave', function() {
            var imageId = this.getAttribute('data-image-id'); // Get the data-image-id from the banner-box
            var blockSection = this.closest('.quiz-inner'); // Find the parent .quiz-inner container
            var images = blockSection.querySelectorAll('.quiz-images[data-image-id="' + imageId + '"]'); // Select all .quiz-images with matching data-image-id
            
            images.forEach(function(image) {
                image.classList.remove('hovered'); // Remove the 'hovered' class from each matched .quiz-images
            });
        });
    });
});